<template>
  <div class="login_warp">
    <div class="login_page" v-if="isLogin === 2">
      <div class="login_wrap_center">
        <div class="header_box">
          <img src="./../assets/pc/logo1.png" alt />
        </div>
        <div class="login_box">
          <div class="head_logo">安全缘</div>
          <div class="form_group">
            <div class="form_item">
              <span>课堂编号：</span>
              <input
                v-model="webForm.tcicClassId"
                placeholder="请输入课堂编号"
              />
            </div>
            <div class="form_item">
              <span>账&emsp;&emsp;号：</span>
              <input v-model="webForm.userName" placeholder="请输入账号" />
            </div>
            <div class="form_item">
              <span>密&emsp;&emsp;码：</span>
              <input
                v-model="webForm.password"
                placeholder="请输入密码"
                type="password"
              />
            </div>
            <el-checkbox
              v-model="checked"
              class="form_item_checkbox"
              @change="handleRemeber"
              >记住密码</el-checkbox
            >
          </div>
          <!-- <button class="login_btn" @click="handleLogin" >登录</button> -->
          <el-button type="primary" :loading="isLoding" class="login_btn" @click="handleLogin">登录</el-button>
        </div>
        <div class="footer_box">
          Copyright © 2020 北京华盾互联科技有限公司|京ICP备18019259号
        </div>
      </div>
    </div>
    <!-- 提示 -->
    <div id="root1"></div>
  </div>
</template>

<script>
// import {AgoraEduSDK} from 'agora-classroom-sdk'
import { login } from "@/api/user.js";
import axios from "axios";
export default {
  name: "login",
  data() {
    return {
      isShowWeb: true, // 是否显示网页或者移动端
      mobileForm: {
        peopledm: "", // 账号
        pwd: "", //密码
        ticClassId: "" // id
      },
      webForm: {
        userName: "", // 账号
        password: "", //密码
        tcicClassId: "", // id
        yjcontk: "SEA"
      },
      isDialog: false,
      isFullscreen: false,
      checked: false, // check，判断是否需要记住密码
      isLogin: 2 ,//1 登录 2退出
      isLoding:false,
    };
  },
  created() {
    window.addEventListener("beforeunload", e => this.handleRefresh(e));
  },
  destroyed() {
    window.removeEventListener("beforeunload", e => this.handleRefresh(e));
  },
  methods: {
    handleRefresh(e) {
      if (this.isLogin === 1) {
        window.confirm("当前页面数据未保存，确定要离开!");
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        return "关闭提示";
      }
    },
    async handleLogin() {
      //   登录
      if (!this.webForm.tcicClassId) {
        this.$message.warning("请输入课堂编号");
        return;
      }
      if (!this.webForm.userName) {
        this.$message.warning("请输入账号");
        return;
      }
      if (!this.webForm.password) {
        this.$message.warning("请输入密码");
        return;
      }
      this.isLoding = true

      let result = await login(this.webForm);

      if (result.code == 0) {
        let data = result.data;
        let token = data.token;
        let customerName = data.customerName;
        let roomName = data.roomName;
        let roleType = data.roleType;
        this.handleRemeber();
        this.handleAgoraEduSDK(
          this.webForm.userName,
          this.webForm.tcicClassId,
          token,
          customerName,
          roomName,
          roleType
        );
      }
      this.loginLoading = false;
    },

    handleAgoraEduSDK(
      userName,
      classId,
      token,
      customerName,
      roomName,
      roleType
    ) {
      let app_id = "f0630cd796524fe18e7dd2c9121aa9f1";
      let user_id = userName;
      let rtm_token = token;
      AgoraEduSDK.config({
        // 此处替换成你的 App ID
        appId: app_id
      });
      AgoraEduSDK.launch(document.querySelector("#root1"), {
        // 此处替换成你的 RTM Token
        rtmToken: rtm_token,
        // 请确保此次的用户 ID 和你在生成临时 RTM Token 时使用的用户 ID 保持一致
        userUuid: user_id,
        userName: customerName,
        roomUuid: classId,
        roomName: roomName,
        roleType: roleType,
        roomType: 2,
        pretest: true,
        language: "zh",
        startTime: new Date().getTime(),
        duration:36000,
        courseWareList: [],
        listener: evt => {
          this.isLogin = evt;
          this.isLoding = false
          console.log("evt", evt);
        }
      });
    },
    // 移动端登录
    async handleSubmitMobile() {
      if (!this.mobileForm.ticClassId) {
        this.countdown();
        this.isDialog = true;
        this.tips = "请输入课程编号";
        return;
      }
      if (!this.mobileForm.peopledm) {
        this.tips = "请输入账号";
        this.isDialog = true;
        this.countdown();
        return;
      }
      //this.$parent.$router.app.userAutoLogin(this.mobileForm);
      this.gotoSicClass(this.mobileForm);
      this.loginLoading = false;

      console.log(this.mobileForm);
      console.log("登录");
    },

    gotoSicClass(data) {
      this.$parent.$router.app.$store.commit("SET_TOKEN", 2);
      window.localStorage.setItem("peopledm", data.peopledm);
      window.localStorage.setItem("pwd", data.pwd);
      window.localStorage.setItem("ticClassId", data.ticClassId);
      if (this._isMobile()) {
        this.$router.push({
          path: "/saas",
          query: {}
        });
      } else {
        this.$router.push({
          path: "/web/paas",
          query: {}
        });
      }
    },
    // 打开弹出层
    countdown() {
      const t = setTimeout(() => {
        this.close();
      }, 1500);
      this.timers.push(t);
    },
    // 关闭弹出层
    close() {
      this.isDialog = false;
    },
    // 记住密码
    handleRemeber() {
      //  逻辑暂无
      if (this.checked) {
        let user = {
          peopledm: this.webForm.peopledm,
          pwd: this.webForm.pwd,
          ticClassId: this.webForm.ticClassId
        };
        this.$cookies.set("user", JSON.stringify(user)); // 保存用户名
      } else {
        this.$cookies.remove("user");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$blue_color: #0088ff;
$active_color: #3a8ee6;

.login_warp {
  .actived {
    border-color: #0a818c;
    color: #0a818c;
  }
  .web_login {
    min-height: 200px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    // background-color: #34363b;
    overflow: hidden;
    .web_dialog__flex {
      display: flex;
      .web_dialog__img {
        flex-shrink: 0;
        vertical-align: top;
        min-height: 200px;
        display: inline-block;
        background-color: #34363b;
        height: 500px;
        width: 444px;
        overflow: hidden;
        box-sizing: content-box;

        position: relative;
        img {
          width: 100%;
        }
      }
      .web_dialog__info {
        display: inline-block;
        overflow: hidden;
        padding: 30px 40px 30px 88px;
        background-color: #fff;
        position: relative;
        width: 444px;
        box-sizing: border-box;
      }
      .web_dialog__body {
        padding: 20px 0;
        width: 268px;
        overflow: hidden;
        .title {
          font-size: 18px;
          border-bottom: 2px solid;
          padding: 2px 0;
        }
        .web_dialog_content {
          padding-top: 20px;

          li {
            border-bottom: 1px solid #737882;
            height: 46px;
            line-height: 46px;
            display: flex;
            .web_txt {
              font-size: 12px;
              color: #737882;
              width: 20%;
              display: inline-block;
            }
            input {
              outline: none;
              border: none;
              width: 80%;
            }
          }
        }
        .web_btn {
          background: #0a818c;
          color: #fff;
          width: 100%;
          font-size: 16px;
          line-height: 40px;
          text-align: center;
          margin-top: 40px;
          cursor: pointer;
        }
      }
    }
    @media screen and (max-width: 900px) {
      .web_dialog__flex {
        display: flex;
        flex-direction: column;
      }
    }
  }
  //   移动端显示
  .mobile_login {
    width: 70%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .mobile_dialog_content {
      input {
        border: 0;
        outline: none;
        background: #212224;
        color: #fff;
      }
      li {
        border-bottom: 1px solid #737882;
        line-height: 40px;
        text-align: left;
      }
    }
    .mobile_btn {
      width: 100px;
      line-height: 36px;
      text-align: center;
      color: #fff;
      font-size: 12px;
      background: $blue_color;
      margin: 30px auto;
    }
  }
  .tips {
    position: absolute;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    color: #fff;
    padding: 5px 10px;
  }
}
</style>
<style lang="scss" scoped>
$blue_color: #0088ff;
$active_color: #3a8ee6;
.login_page {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #11c1fa;
  background-image: url("~@/assets/pc/bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  .login_wrap_center {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 980px;
    height: 650px;
  }
  .login_box {
    width: 980px;
    height: 540px;
    background: url("~@/assets/pc/login_wrap.png") no-repeat center;
    background-size: 100%;
    border-radius: 6px;
    position: absolute;
    .head_logo {
      height: 60px;
      line-height: 60px;
      margin-top: 42px;
      margin-left: 46px;
      padding-left: 68px;
      color: $blue_color;
      font-size: 47px;
      background: url("~@/assets/pc/logo2.png") no-repeat;
      background-size: 60px;
      background-position: left;
    }
  }
  .form_group {
    padding-top: 55px;
    padding-left: 49px;
    .form_item {
      width: 300px;
      height: 50px;
      line-height: 50px;
      border-radius: 25px;
      background: #eef2f4;
      margin-bottom: 23px;
      display: flex;
      align-items: center;
      span {
        font-size: 18px;
        color: #666;
        padding-left: 20px;
        float: left;
      }
      input {
        float: left;
        font-size: 18px;
        border: 0;
        background: #eef2f4;
        outline: none;
        width: 150px;
      }
    }
    .form_item_checkbox {
      padding-left: 20px;
      color: #666666;
    }
  }
  .login_btn {
    width: 300px;
    height: 50px;
    // line-height: 50px;
    font-size: 18px;
    color: #fff;
    background: $blue_color;
    border: 0;
    border-radius: 25px;
    outline: none;
    margin: 35px 0 0 42px;
    cursor: pointer;
    &:active {
      background: $active_color;
    }
  }
  .header_box {
    img {
      width: 200px;
      height: 50px;
    }
    margin-bottom: 23px;
    margin-left: 45px;
  }
  .footer_box {
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    position: relative;
    top: 560px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue